import { makeErrorWithCode } from './makeErrorWithCode';

export const NeverError = makeErrorWithCode('ASSERT_NEVER_ERROR', (_value: never) => 'Something went wrong.');
